module.exports = __webpack_public_path__ + "img/clockfill.c5022705.svg";